/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from 'pdfmake/build/pdfmake';
import { IConferenciaNotas } from '../../../shared/services/api/fiscal/LCDPR/LCDPRService';
import moment from 'moment';
 
async function RelatoriosaldoConferenciaNotas(dados: IConferenciaNotas[], produtor: string, periodo: string){
  
  const TTotal = dados.reduce((acc, item) => acc + item.saida , 0);
  const rows = dados.map((row) => {
    return [
      {text: moment(row.dataemissao).format('DD/MM/YYYY'), alignment: 'center',  fontSize: 7},
      {text: row.numero, alignment: 'left',  fontSize: 7},
      {text: row.nome, alignment: 'left',  fontSize: 7},
      {text: (row.cpf.length == 11 ? (
        row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      ) : (
        row.cpf.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      )), fontSize: 7, alignment: 'left'},
      {text: row.historicolcdpr, alignment: 'left',  fontSize: 7},
      {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(row.saida), alignment: 'right', fontSize: 7},
    ]; 
  });  

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img: HTMLImageElement = new Image();
      img.crossOrigin = 'Anonymous'; 
      img.onload = function () {
        const canvas: HTMLCanvasElement = document.createElement('canvas');  
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject('Não foi possível obter o contexto 2D');
          return;
        }
        const image = this as HTMLImageElement;
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        const dataURL = canvas.toDataURL('image/png');
        resolve(dataURL);
      };
      img.onerror = function () {
        reject(`Não foi possível carregar a imagem de ${url}`);
      };
      img.src = url;
    });
  }

  const imageUrl =  process.env.REACT_APP_URL_IMGLOG || ''; 
  const imageData = await getBase64ImageFromUrl(imageUrl);

  if (!imageData.startsWith('data:image')) {
    return new Error('A imagem não foi convertida corretamente para base64.');
  }

  const documentDefinition : any = {
    pageSize: 'A4',
    pageMargins: [20, 10, 10, 20],
    header: 'simple text',
    footer: {
      columns: [
        '',
        { text: '', alignment: 'right' }
      ]
    },
    content: ([
      {   
        table: {
          body: [
            [ 
              {
                image: imageData,
                width: 48,
                border: [false, false, false, false]
              },
              {
                border: [false, false, false, false],  
                table: {
                  widths: [500],
                  body: [
                    [ 
                      {text: process.env.REACT_APP_URL_EMPRESA, fontSize: 16,  margin: [0, 5, 0, 0], bold: true, color: '#FFFFFF',  alignment: 'center', fillColor: process.env.REACT_APP_URL_EMPRESA, border: [false, false, false, false]},
                    ],
                    [ 
                      {text: process.env.REACT_APP_URL_ENDERECO, fontSize: 10, border: [false, false, false, true]},
                    ],
                  ]
                }
              },
              
            ],
            [
              {text: 'Relatório de Conferência de Notas', colSpan: 2, margin: [5, 10, 0, 0], fontSize: 18, bold: true,  alignment: 'center',  border: [false, false, false, false]},
              {}
            ]
            
          ]
        }
      },
      {text: produtor,  fontSize: 14},
      {text: periodo,  fontSize: 10},
      {
        table:{
          widths: [40, 40, 145, 70, 145, 55],
          body: [
            [
              {text: 'Emissão', alignment: 'center', fillColor: '#dddddd', fontSize: 8},
              {text: 'Numero', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
              {text: 'Parceiro', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
              {text: 'CNPJ/CPF', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
              {text: 'Histórico', alignment: 'left', fillColor: '#dddddd', fontSize: 8},
              {text: 'Valor', alignment: 'right', fillColor: '#dddddd', fontSize: 8},
            ],
            ...rows,
            [
              {text: 'Totais', colSpan: 5, fontSize: 10, alignment: 'right',  border: [false, false, false, false]},
              {},
              {},
              {},
              {},
              {text: new Intl.NumberFormat('pt-br', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(TTotal), alignment: 'right', fontSize: 8},
            ]
          ]
          
        },
      },
      
    ]),
      
  };

  const pdfDocGenerator = pdfMake.createPdf(documentDefinition);

  pdfDocGenerator.open();
}
export default RelatoriosaldoConferenciaNotas;

